import script from "./cb-widget-integration.vue?vue&type=script&setup=true&lang=ts"
export * from "./cb-widget-integration.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__